<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            layout="total, sizes, prev, pager, next, jumper"
            background
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </template>
    <div class="file-list-wrapper">
      <file-list-cell
        v-for="file in files"
        :key="file.id"
        :file="file"
        :is-placeholder="isLoading"
        @deleteFile="handleRemoveFile"
      />
    </div>
  </sticky-header-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FileListCell from './components/FileListCell.vue'

export default {
  name: 'FileList',
  components: {
    FileListCell,
  },
  computed: {
    ...mapGetters({
      files: 'file/files',
      listQuery: 'file/fileQuery',
      isLoading: 'file/isLoadingFiles',
    }),
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions({
      getList: 'file/getFileList',
      handleSizeChange: 'file/setSizeQuery',
      handlePageChange: 'file/setPageQuery',
    }),
    handleRemoveFile(file) {
      const toBeRemovedFileIndex = this.files.indexOf(file)
      this.files.splice(toBeRemovedFileIndex, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";

section {
  .file-list-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
  }
}
</style>
